import { Pipe, PipeTransform } from '@angular/core';

export const userFullNameFn = (value: { firstName?: string | null; lastName?: string | null }): string => {
  return `${value.firstName ? value.firstName : ''} ${value.lastName ? value.lastName : ''}`.trim();
};

@Pipe({
  name: 'userFullName',
  standalone: true,
})
export class UserFullNamePipe implements PipeTransform {
  transform(value: { firstName?: string | null; lastName?: string | null }): string {
    this;
    return userFullNameFn(value);
  }
}
